import { getLogger } from "lib/util";

const log = getLogger("lib.designer.FindDesignerComponents");

export function findDesignerComponent(content, compName) {
  let tokens = compName.split(".");
  return findComponentInArray(content, tokens, 5, false, null); // there are 4 elements in the component hierarchy.  Will need to adjust this if/when we add more to the designer
}

export function findDesignerParentAndIndex(content, compName) {
  let tokens = compName.split(".");
  return findComponentInArray(content, tokens, 5, true, null); // there are 4 elements in the component hierarchy.  Will need to adjust this if/when we add more to the designer
}

function findComponentInArray(content, compNames, nameIndex, returnParentAndIndex, parentRef) {
  let searchName = compNames[nameIndex];
  for (let i = 0; i < content.length; i++) {
    if (content[i].name === searchName) {
      if (nameIndex === compNames.length - 1) {
        if (returnParentAndIndex) {
          if (parentRef == null)
            throw new Error("Expected a parent ref, but found this item in the top level content.");
          return { parent: parentRef, index: i };
        }
        else
          return content[i];
      }
      else {
        let children = content[i].children;
        if (children == null)
          log.error("Returning null from FCIA because expected children on a component with none.  %o   %o", content, compNames);
        return findComponentInArray(children, compNames, nameIndex + 1, returnParentAndIndex, content[i]);
      }
    }
  }
  log.error("Returning null from FCIA %o  %o", compNames, content);
  return null;
}
